// import axios from "axios";
// import React, { useEffect, useState } from "react";
// import { useNavigate } from "react-router-dom";
// import Swal from "sweetalert2";
// import "./AllSubject.css";

// const API_BASE_URL = process.env.REACT_APP_API_BASEURL;

// const AllSubject = () => {
//   const navigate = useNavigate();

//   const [boards, setBoards] = useState([]);
//   const [classes, setClasses] = useState([]);
//   const [selectedBoard, setSelectedBoard] = useState("");
//   const [selectedClass, setSelectedClass] = useState("");
//   const [allSubjects, setAllSubjects] = useState([]);

//   /* ================= FETCH BOARDS ================= */

//   useEffect(() => {
//     const fetchBoards = async () => {
//       try {
//         const response = await axios.get(
//           `${API_BASE_URL}/boards`,
//           {
//             headers: {
//               Authorization:
//                 "Bearer " + localStorage.getItem("token"),
//             },
//           }
//         );

//         setBoards(response.data.data || []);
//       } catch (error) {
//         Swal.fire("Error", "Failed to fetch boards", "error");
//       }
//     };

//     fetchBoards();
//   }, []);

//   /* ================= FETCH CLASSES BY BOARD ================= */

//   useEffect(() => {
//     if (!selectedBoard) {
//       setClasses([]);
//       setSelectedClass("");
//       return;
//     }

//     const fetchClasses = async () => {
//       try {
//         const response = await axios.get(
//           `${API_BASE_URL}/classes/board/${selectedBoard}`,
//           {
//             headers: {
//               Authorization:
//                 "Bearer " + localStorage.getItem("token"),
//             },
//           }
//         );

//         setClasses(response.data.data || []);
//       } catch (error) {
//         Swal.fire("Error", "Failed to fetch classes", "error");
//       }
//     };

//     fetchClasses();
//   }, [selectedBoard]);

//   /* ================= FETCH SUBJECTS ================= */

//   const handleSearch = async (e) => {
//     e.preventDefault();

//     if (!selectedClass) {
//       return Swal.fire("Warning", "Please select class", "warning");
//     }

//     try {
//       const result = await axios.get(
//         `${API_BASE_URL}/subjects?reference=${selectedClass}`,
//         {
//           headers: {
//             Authorization:
//               "Bearer " + localStorage.getItem("token"),
//           },
//         }
//       );

//       setAllSubjects(result.data.data || []);
//     } catch (error) {
//       Swal.fire("Error", "Failed to fetch subjects", "error");
//     }
//   };

//   /* ================= DELETE SUBJECT ================= */

//   const handleDelete = async (id) => {
//     const confirm = await Swal.fire({
//       title: "Are you sure?",
//       text: "You won’t be able to revert this!",
//       icon: "warning",
//       showCancelButton: true,
//       confirmButtonColor: "#d33",
//       cancelButtonColor: "#3085d6",
//       confirmButtonText: "Yes, delete it!",
//     });

//     if (confirm.isConfirmed) {
//       try {
//         await axios.delete(
//           `${API_BASE_URL}/subjects/${id}`,
//           {
//             headers: {
//               Authorization:
//                 "Bearer " + localStorage.getItem("token"),
//             },
//           }
//         );

//         setAllSubjects((prev) =>
//           prev.filter((subject) => subject._id !== id)
//         );

//         Swal.fire("Deleted!", "Subject deleted.", "success");
//       } catch (error) {
//         Swal.fire("Error", "Failed to delete subject", "error");
//       }
//     }
//   };

//   const handleEdit = (id) => {
//     navigate(`/school-edit-subject/${id}`);
//   };

//   return (
//     <div id="classes-inner-wrapper">
//       <div className="classes-header-div">
//         <h5>All Subjects</h5>
//         <div className="classes-header-btns">
//           <button
//             className="add-class-btn"
//             onClick={() => navigate("/school-add-subject")}
//           >
//             + Add New Subject
//           </button>
//         </div>
//       </div>

//       {/* ================= FILTER SECTION ================= */}

//       <div className="school-all-subject-filter-main">
//         <form onSubmit={handleSearch}>

//           {/* BOARD */}
//           <div className="input-group">
//             <label className="label">Select Board</label>
//             <select
//               value={selectedBoard}
//               onChange={(e) =>
//                 setSelectedBoard(e.target.value)
//               }
//               required
//             >
//               <option value="">-Select Board-</option>
//               {boards.map((board) => (
//                 <option key={board._id} value={board._id}>
//                   {board.boardName}
//                 </option>
//               ))}
//             </select>
//           </div>

//           {/* CLASS */}
//           <div className="input-group">
//             <label className="label">Select Class</label>
//             <select
//               value={selectedClass}
//               onChange={(e) =>
//                 setSelectedClass(e.target.value)
//               }
//               disabled={!selectedBoard}
//               required
//             >
//               <option value="">-Select Class-</option>
//               {classes.map((cls) => (
//                 <option key={cls._id} value={cls._id}>
//                   {cls.className}
//                 </option>
//               ))}
//             </select>
//           </div>

//           <button className="btn-search" type="submit">
//             Search
//           </button>
//         </form>
//       </div>

//       {/* ================= TABLE ================= */}

//       <div className="classes-table-container">
//         <h5>Subjects List</h5>

//         <table className="classes-table">
//           <thead>
//             <tr>
//               <th>S.No.</th>
//               <th>Subject</th>
//               <th>Action</th>
//             </tr>
//           </thead>

//           <tbody>
//             {allSubjects.length > 0 ? (
//               allSubjects.map((data, idx) => (
//                 <tr key={data._id}>
//                   <td>{idx + 1}</td>
//                   <td>{data.subjectName}</td>
//                   <td className="table-action-icons">
//                     <i
//                       className="fa-solid fa-file-pen"
//                       onClick={() => handleEdit(data._id)}
//                     ></i>
//                     &nbsp;&nbsp;
//                     <i
//                       className="fa-solid fa-trash-can"
//                       onClick={() =>
//                         handleDelete(data._id)
//                       }
//                     ></i>
//                   </td>
//                 </tr>
//               ))
//             ) : (
//               <tr>
//                 <td colSpan="3" style={{ textAlign: "center" }}>
//                   No Subjects Found
//                 </td>
//               </tr>
//             )}
//           </tbody>
//         </table>
//       </div>
//     </div>
//   );
// };

// export default AllSubject;


































import axios from "axios";
import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import Swal from "sweetalert2";
import "./AllSubject.css";

const API_BASE_URL = process.env.REACT_APP_API_BASEURL;

const AllSubject = () => {
  const navigate = useNavigate();

  const [boards, setBoards] = useState([]);
  const [classes, setClasses] = useState([]);
  const [selectedBoard, setSelectedBoard] = useState("");
  const [selectedClass, setSelectedClass] = useState("");
  const [allSubjects, setAllSubjects] = useState([]);

  /* ================= FETCH BOARDS ================= */

  useEffect(() => {
    const fetchBoards = async () => {
      try {
        const response = await axios.get(
          `${API_BASE_URL}/boards`,
          {
            headers: {
              Authorization:
                "Bearer " + localStorage.getItem("token"),
            },
          }
        );

        setBoards(response.data.data || []);
      } catch (error) {
        Swal.fire("Error", "Failed to fetch boards", "error");
      }
    };

    fetchBoards();
  }, []);

  /* ================= FETCH CLASSES BY BOARD ================= */

  useEffect(() => {
    if (!selectedBoard) {
      setClasses([]);
      setSelectedClass("");
      return;
    }

    const fetchClasses = async () => {
      try {
        const response = await axios.get(
          `${API_BASE_URL}/classes/board/${selectedBoard}`,
          {
            headers: {
              Authorization:
                "Bearer " + localStorage.getItem("token"),
            },
          }
        );

        setClasses(response.data.data || []);
      } catch (error) {
        Swal.fire("Error", "Failed to fetch classes", "error");
      }
    };

    fetchClasses();
  }, [selectedBoard]);

  /* ================= FETCH SUBJECTS ================= */

  const handleSearch = async (e) => {
    e.preventDefault();

    if (!selectedClass) {
      return Swal.fire("Warning", "Please select class", "warning");
    }

    try {
      const result = await axios.get(
        `${API_BASE_URL}/subjects?reference=${selectedClass}`,
        {
          headers: {
            Authorization:
              "Bearer " + localStorage.getItem("token"),
          },
        }
      );

      setAllSubjects(result.data.data || []);
    } catch (error) {
      Swal.fire("Error", "Failed to fetch subjects", "error");
    }
  };

  /* ================= DELETE SUBJECT ================= */

  const handleDelete = async (id) => {
    const confirm = await Swal.fire({
      title: "Are you sure?",
      text: "You won’t be able to revert this!",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#d33",
      cancelButtonColor: "#3085d6",
      confirmButtonText: "Yes, delete it!",
    });

    if (confirm.isConfirmed) {
      try {
        await axios.delete(
          `${API_BASE_URL}/subjects/${id}`,
          {
            headers: {
              Authorization:
                "Bearer " + localStorage.getItem("token"),
            },
          }
        );

        setAllSubjects((prev) =>
          prev.filter((subject) => subject._id !== id)
        );

        Swal.fire("Deleted!", "Subject deleted.", "success");
      } catch (error) {
        Swal.fire("Error", "Failed to delete subject", "error");
      }
    }
  };

  const handleEdit = (id) => {
    navigate(`/school-edit-subject/${id}`);
  };

  return (
    <div id="classes-inner-wrapper">
      <div className="classes-header-div">
        <h5>All Subjects</h5>
        <div className="classes-header-btns">
          <button
            className="add-class-btn"
            onClick={() => navigate("/school-add-subject")}
          >
            + Add New Subject
          </button>
        </div>
      </div>

      {/* ================= FILTER SECTION ================= */}

      <div className="school-all-subject-filter-main">
        <form onSubmit={handleSearch}>

          {/* BOARD */}
          <div className="input-group">
            <label className="label">Select Board</label>
            <select
              value={selectedBoard}
              onChange={(e) =>
                setSelectedBoard(e.target.value)
              }
              required
            >
              <option value="">-Select Board-</option>
              {boards.map((board) => (
                <option key={board._id} value={board._id}>
                  {board.boardName}
                </option>
              ))}
            </select>
          </div>

          {/* CLASS */}
          <div className="input-group">
            <label className="label">Select Class</label>
            <select
              value={selectedClass}
              onChange={(e) =>
                setSelectedClass(e.target.value)
              }
              disabled={!selectedBoard}
              required
            >
              <option value="">-Select Class-</option>
              {classes.map((cls) => (
                <option key={cls._id} value={cls._id}>
                  {cls.className}
                </option>
              ))}
            </select>
          </div>

          <button className="btn-search" type="submit">
            Search
          </button>
        </form>
      </div>

      {/* ================= TABLE ================= */}

      <div className="classes-table-container">
        <h5>Subjects List</h5>

        <table className="classes-table">
          <thead>
            <tr>
              <th>S.No.</th>
              <th>Subject</th>
              <th>Action</th>
            </tr>
          </thead>

          <tbody>
            {allSubjects.length > 0 ? (
              allSubjects.map((data, idx) => (
                <tr key={data._id}>
                  <td>{idx + 1}</td>
                  <td>{data.subjectName}</td>
                  <td className="table-action-icons">
                    <i
                      className="fa-solid fa-file-pen"
                      onClick={() => handleEdit(data._id)}
                    ></i>
                    &nbsp;&nbsp;
                    <i
                      className="fa-solid fa-trash-can"
                      onClick={() =>
                        handleDelete(data._id)
                      }
                    ></i>
                  </td>
                </tr>
              ))
            ) : (
              <tr>
                <td colSpan="3" style={{ textAlign: "center" }}>
                  No Subjects Found
                </td>
              </tr>
            )}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default AllSubject;